import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { FAQ } from '../types';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<string | null>("1");

  const faqs: FAQ[] = [
    {
      id: "1",
      question: "How long does it take to implement automation?",
      answer: "Implementation timelines vary based on complexity. Simple workflows can be deployed in 1-2 weeks, while comprehensive automation systems typically take 4-8 weeks. We provide a detailed timeline during your free audit."
    },
    {
      id: "2",
      question: "Do I need technical knowledge to use your automations?",
      answer: "Not at all! We build user-friendly systems that require zero technical knowledge. We provide comprehensive training and documentation, plus ongoing support to ensure your team can manage everything confidently."
    },
    {
      id: "3",
      question: "What if my business processes change?",
      answer: "Our automation systems are designed to be flexible and scalable. We offer ongoing optimization services to adapt your workflows as your business evolves. Most clients see continuous improvements over time."
    },
    {
      id: "4",
      question: "How do you ensure data security?",
      answer: "We follow industry-standard security practices including encrypted data transmission, secure API connections, and compliance with GDPR and other regulations. All integrations are thoroughly tested for security vulnerabilities."
    },
    {
      id: "5",
      question: "What kind of ROI can I expect?",
      answer: "Most clients see ROI within 3-6 months through time savings, reduced errors, and increased capacity. On average, businesses save 40-70 hours monthly and reduce operational costs by 45-60%. We provide detailed ROI projections during your audit."
    },
    {
      id: "6",
      question: "Do you offer ongoing support?",
      answer: "Yes! All plans include support, with response times varying by tier. Growth and Enterprise plans include priority support, regular optimization calls, and proactive monitoring to ensure your automations run smoothly."
    }
  ];

  const toggleFAQ = (id: string) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <section className="bg-background py-16 lg:py-24">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 space-y-4">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-accent/10 rounded-full">
              <Icon name="HelpCircle" size={16} className="text-accent" />
              <span className="text-sm font-medium text-accent">FAQ</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-text-secondary">
              Everything you need to know about our automation services
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className="bg-card rounded-lg border border-border overflow-hidden hover:border-primary transition-colors duration-300"
              >
                <button
                  onClick={() => toggleFAQ(faq.id)}
                  className="w-full flex items-center justify-between p-6 text-left"
                  aria-expanded={openFAQ === faq.id}
                >
                  <h3 className="text-lg font-semibold text-text-primary pr-4">
                    {faq.question}
                  </h3>
                  <Icon
                    name={openFAQ === faq.id ? "ChevronUp" : "ChevronDown"}
                    size={20}
                    className="text-text-secondary flex-shrink-0"
                  />
                </button>

                {openFAQ === faq.id && (
                  <div className="px-6 pb-6 animate-fade-in">
                    <p className="text-text-secondary leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;